/* global window */
import slug from "slug";

export default (currentValue, propertyName) => ({
  debouncedUpdate: undefined,
  slug: currentValue,
  confirmed: false,
  confirm(e) {
    e.preventDefault();
    this.confirmed = true;
  },
  handleEmptySlug(value) {
    this.confirmed = true;
    this.slug = value;
    this.generateSlug();
  },
  generateSlug() {
    // We want to allow people to type dashes at the end of the slug so we add { trim: false }
    // but this also allows adding a space at the beginning so we first trim the start before generating the slug
    const slugValue = slug(this.slug.trimStart(), { trim: false });
    // We then remove any dashes at the start of the slug
    this.slug = slugValue.replace(/^-+/, "");
    this.validateSlug();
  },
  validateSlug() {
    if (!this.debouncedUpdate) {
      this.debouncedUpdate = window.Alpine.debounce(function () {
        this.$wire.set(propertyName, this.slug);
      }, 350);
    }

    this.debouncedUpdate();
  },
});
